<template>
  <component
    :is="layout"
    v-if="!!layout"
  >
    <router-view />
    <v-snackbar
      v-model="showSnackbarError"
      color="error"
      :multi-line="true"
    >
      {{ errorMessage }}
      <v-btn
        dark
        flat
        @click="
          showSnackbarError = false
          snackbarError = undefined
        "
      >
        {{ $t('message.close') }}
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="showSnackbarMessage"
      color="success"
      :multi-line="true"
    >
      {{ snackbarMessage }}
      <v-btn
        dark
        flat
        @click="
          showSnackbarMessage = false
          snackbarMessage = undefined
        "
      >
        {{ $t('message.close') }}
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="showSnackbarWarning"
      color="warning"
      :multi-line="true"
    >
      {{ snackbarWarning }}
      <v-btn
        dark
        flat
        @click="
          showSnackbarWarning = false
          snackbarWarning = undefined
        "
      >
        {{ $t('message.close') }}
      </v-btn>
    </v-snackbar>
  </component>
</template>

<script>
import AppLayout from './layouts/AppLayout'
import SimpleLayout from './layouts/SimpleLayout'
import { mapGetters, mapState } from 'vuex'
import Activate from './components/user/Activate'

export default {
  name: 'App',
  components: {
    Activate,
    AppLayout,
    SimpleLayout,
  },
  data: () => ({
    snackbarMessage: undefined,
    snackbarWarning: undefined,
    snackbarError: undefined,
    showSnackbarError: false,
    layout: '',
  }),
  computed: {
    errorMessage() {
      if (this.snackbarError) return this.snackbarError
      if (!this.serviceError) return ''
      const key = 'serviceMessages.' + this.serviceError.message
      return this.$te(key) ? this.$t(key) : this.serviceError.message
    },
    showSnackbarMessage: {
      get: function () {
        return !!this.snackbarMessage
      },
      set: function (value) {
        if (value === false) {
          this.snackbarMessage = undefined
        }
      },
    },
    showSnackbarWarning: {
      get: function () {
        return !!this.snackbarWarning
      },
      set: function (value) {
        if (value === false) {
          this.snackbarWarning = undefined
        }
      },
    },
    ...mapState(['serviceError', 'user']),
  },
  watch: {
    $route(to, from) {
      if (['login', 'register'].includes(to.name)) {
        this.layout = 'simple-layout'
      } else if (this.user._id && !this.user.active && to.name !== 'activate') {
        this.$router.replace({ name: 'activate' })
      } else {
        this.layout = 'app-layout'
      }
    },
  },
  created() {
    document.title = process.env.VUE_APP_TITLE
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
      case 'showSnackbarMessage':
        this.snackbarMessage = this.$te(mutation.payload)
          ? this.$t(mutation.payload)
          : mutation.payload
        break
      case 'showSnackbarWarning':
        this.snackbarWarning = this.$te(mutation.payload)
          ? this.$t(mutation.payload)
          : mutation.payload
        break
      case 'showServiceError':
        this.snackbarError = undefined
        this.showSnackbarError = true
        break
      case 'showSnackbarError':
        this.showSnackbarError = true
        this.snackbarError = this.$te(mutation.payload)
          ? this.$t(mutation.payload)
          : mutation.payload
        break
      }
    })
  },
  mounted() {
    if (this.user._id && !this.user.active) {
      this.$router.replace({ name: 'activate' })
    }
    this.layout = ['login', 'register', 'resetpassword'].includes(
      this.$router.currentRoute.name
    )
      ? 'simple-layout'
      : 'app-layout'
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.application.theme--light .theme--light.v-input--is-disabled .v-label,
.application.theme--light .theme--light.v-input--is-disabled input,
.application.theme--light .theme--light.v-input--is-disabled textarea {
  color: #444;
}
footer {
  text-align: center;
}
</style>
